
import Vue from 'vue';
import Component from 'vue-class-component';
import DocumentPageCanvas from './DocumentPageCanvas.vue';
import DesignPreview from '@/views/printSetting/pagePreview/designPreview/designPreview.vue';
import DesignBorder from '@/views/printSetting/pagePreview/designBorder/designBorder.vue';

import { Page } from '@/model/document2/page/page';
import { Surface } from '@/model/document2/page/surface/surface';
import { Design } from '@/model/document2/page/surface/design/design';
import { ColorConstruct } from '@/utilityModels/colorConstruct';
import { Rectangle } from '@/utilityModels/rectangle';
import { UuidHelper } from '@/helper/uuidHelper';
import { UnitHelper } from '@/helper/unitHelper';
import { ImageHelper } from "@/helper/imageHelper";

@Component({
    props: {
        pageIndex: {
            type: Number,
            default: 0
        },
        page: {
            type: Page,
            required: true,
        },
        documentRotate: {
            type: Number,
            default: 0,
        },
        isReverseSurface: {
            type: Boolean,
            default: false,
        },
        hasBorder: {
            type: Boolean,
            default: false,
        },
        borderColor: {
            type: ColorConstruct,
            default: new ColorConstruct(151, 151, 151),
        },
        transform: {
            type: String,
            default: '',
        },
    },
    components: {
        DocumentPageCanvas,
        DesignPreview,
        DesignBorder,
    },
})
export default class DocumentPage extends Vue {
    // 横 (mm)
    public get mmWidth(): number {
        return this.$props.page.width;
    }

    // 縦 (mm)
    public get mmHeight(): number {
        return this.$props.page.height;
    }

    // ページから面を得る
    private get surface(): Surface {
        return this.$props.page.getSurface(this.$props.isReverseSurface);
    }

    // 面からデザインのリストを得る
    private get designs(): (Design | null)[] {
        let designs: (Design | null)[] = [];
        for (let i = 0; i < this.$props.page.designMaxNumber; i++) {
            const design = this.surface.getDesign(i);
            designs.push(design);
        }
        return designs;
    }

    // FIXME maskのidにしか使っていないのでDesignPreviewの中で生成したらいい気がする
    private get tmpId(): string {
        return UuidHelper.getUuid();
    }

    // FIXME 同上
    // document内で一意なmask用idを作る
    private createDesignId(i: number): string {
        return `${this.tmpId}_${i}`
    }

    private shouldPrintDesign(i: number): boolean {
        // 本来、印刷とそれ以外でContextが切り替わる
        // とりあえず今のDocumentPageは印刷用なのでこれで
        return this.surface.isPrintable(i);
    }

    // frameImage
    private get frameImageSource()
    {
        // FrameImageを取得する
        var frameImage = this.$props.page.getSurface(this.$props.isReverseSurface).getFrameImage(0);
        if(frameImage != "")
        {
            // 線幅、線色を適用する
            var borderWidth = UnitHelper.convert(1, "pt", "mm");;
            var borderColor = this.$props.borderColor;
            var vectorEffect = "";
            frameImage = ImageHelper.changeBase64SVGStroke(frameImage, borderWidth, borderColor, vectorEffect);
        }
        return frameImage;
    }

    private get frameImageWidth()
    {
        var mm = this.$props.documentRotate == 90 || this.$props.documentRotate == 270 ? this.$props.page.height : this.$props.page.width;
        return UnitHelper.convert(mm, "mm", "px", 72);
    }

    private get frameImageHeight()
    {
        var mm = this.$props.documentRotate == 90 || this.$props.documentRotate == 270 ? this.$props.page.width : this.$props.page.height;
        return UnitHelper.convert(mm, "mm", "px", 72);
    }

    private get frameImageTransform()
    {
        var transform = "";

        // オフセット
        // 回転角ごと適切な位置補正を加える
        var w = UnitHelper.convert(this.$props.page.width, "mm", "px", 72);
        var h = UnitHelper.convert(this.$props.page.height, "mm", "px", 72);
        var dx = 0;
        var dy = 0;
        if(this.$props.documentRotate == 90)
        {
            dx = w;
        }
        else if(this.$props.documentRotate == 180)
        {
            dx = w;
            dy = h;
        }
        else if(this.$props.documentRotate == 270)
        {
            dy = h;
        }
        transform += "translate(" + dx + " " + dy + "),";

        // 用紙回転角で回転
        transform += "rotate(" + this.$props.documentRotate + ")";

        return transform;
    }

    private get documentMaskId() { return "document_page_frame_mask_" + this.$props.pageIndex + "_" + (this.$props.isReverseSurface ? "1" : "0"); }
    private get documentMaskIdUrl() { return "url(#" + this.documentMaskId + ")"; }

    private get frameMaskExtention() { return Math.ceil(UnitHelper.convert(0.5, "pt", "mm")); }

    private getDesignRectScaled(position)
    {
        var rect = this.getDesignRect(position);
        var x = UnitHelper.convert(rect.x, "mm", "px", 72);
        var y = UnitHelper.convert(rect.y, "mm", "px", 72);
        var w = UnitHelper.convert(rect.width, "mm", "px", 72);
        var h = UnitHelper.convert(rect.height, "mm", "px", 72);
        return new Rectangle(x, y, w, h);
    }

    private getDesignRect(position)
    {
        return this.$props.page.getSurface(this.$props.isReverseSurface).getDesignRect(position);
    }
}
